var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import * as classnames from "classnames";
var Pane = function (_a) {
    var children = _a.children, _b = _a.hide, hide = _b === void 0 ? false : _b, _c = _a.padding, padding = _c === void 0 ? false : _c, _d = _a.transparent, transparent = _d === void 0 ? false : _d, _e = _a.id, id = _e === void 0 ? null : _e, _f = _a.role, role = _f === void 0 ? null : _f;
    var renderPaneBody = function () {
        var body = children;
        if (padding) {
            body = React.createElement("div", { className: "wds-pane__body" }, children);
            return body;
        }
        return body;
    };
    var getPaneClassNames = function () {
        return classnames("wds-pane", { "wds-pane--transparent": transparent }, { "wds-pane--hide": hide });
    };
    var outerProps = __assign({}, (role && { role: role }), (id && { id: id }));
    return (React.createElement("div", __assign({ className: getPaneClassNames() }, outerProps), renderPaneBody()));
};
export default Pane;
//# sourceMappingURL=Pane.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Pane/Pane.js
// module id = 1799
// module chunks = 17